import React from "react";
import {
    BellOutlined,
    MailOutlined,
    NotificationOutlined,
    PhoneOutlined,
    ShopOutlined,
    UserOutlined,
} from "@ant-design/icons";

const PRIORITY_COLOR = {
    High: {
        bg: "var(--color-error-light)",
        color: "var(--color-error)",
        border: "var(--color-error)",
    },
    Medium: {
        bg: "var(--color-warning-light)",
        color: "var(--color-warning)",
        border: "var(--color-warning)",
    },
    Low: {
        bg: "var(--color-success-light)",
        color: "var(--color-success)",
        border: "var(--color-success)",
    },
};

const baseChipStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: "2px 9px",
    borderRadius: 6,
    fontSize: 11,
    border: "1px solid",
    lineHeight: 1.5,
};

export const PriorityTag = ({ label }) => {
    const style = PRIORITY_COLOR[label] ?? {};
    return (
        <span
            style={{
                display: "inline-block",
                padding: "2px 10px",
                borderRadius: 20,
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.04em",
                background: style.bg,
                color: style.color,
                border: `1px solid ${style.border}`,
            }}
        >
            {label}
        </span>
    );
};

export const AlarmNameCell = ({ value }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div
            style={{
                width: 28,
                height: 28,
                borderRadius: 8,
                background: "var(--color-primary-light)",
                border: "1px solid var(--color-border)",
                color: "var(--color-primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            <BellOutlined style={{ fontSize: 13 }} />
        </div>
        <span style={{ fontWeight: 600, color: "var(--color-text)" }}>
            {value}
        </span>
    </div>
);

export const ChipList = ({
    items,
    icon = null,
    bg = "var(--color-primary-light)",
    border = "var(--color-border)",
    color = "var(--color-primary)",
    emptyLabel = "—",
}) => {
    const filteredItems = items?.filter(Boolean) ?? [];

    if (!filteredItems.length) {
        return (
            <span style={{ color: "var(--color-text-muted)", fontSize: 12 }}>
                {emptyLabel}
            </span>
        );
    }

    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {filteredItems.map((item, index) => (
                <span
                    key={`${item}-${index}`}
                    style={{
                        ...baseChipStyle,
                        background: bg,
                        borderColor: border,
                        color,
                    }}
                >
                    {icon}
                    {item}
                </span>
            ))}
        </div>
    );
};

export const ContactList = ({
    items,
    icon,
    color = "var(--color-text-secondary)",
    emptyLabel = "—",
}) => {
    const filteredItems = items?.filter(Boolean) ?? [];

    if (!filteredItems.length) {
        return (
            <span style={{ color: "var(--color-text-muted)", fontSize: 12 }}>
                {emptyLabel}
            </span>
        );
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {filteredItems.map((item, index) => (
                <span
                    key={`${item}-${index}`}
                    style={{
                        fontSize: 12,
                        color,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                    }}
                >
                    {icon}
                    {item}
                </span>
            ))}
        </div>
    );
};

export const CreatedByCell = ({ firstName, lastName }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <div
            style={{
                width: 28,
                height: 28,
                borderRadius: 8,
                background: "var(--color-primary-light)",
                border: "1px solid var(--color-border)",
                color: "var(--color-primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 11,
                flexShrink: 0,
            }}
        >
            {firstName?.[0]?.toUpperCase() || (
                <UserOutlined style={{ fontSize: 12 }} />
            )}
        </div>
        <span style={{ color: "var(--color-text-secondary)", fontSize: 13 }}>
            {`${firstName || ""} ${lastName || ""}`.trim() || "—"}
        </span>
    </div>
);

export const hotelChipIcon = (
    <ShopOutlined style={{ fontSize: 11, color: "inherit" }} />
);

export const alarmTypeChipIcon = (
    <NotificationOutlined style={{ fontSize: 11, color: "inherit" }} />
);

export const emailListIcon = (
    <MailOutlined style={{ fontSize: 11, color: "var(--color-text-muted)" }} />
);

export const phoneListIcon = (
    <PhoneOutlined
        style={{ fontSize: 11, color: "var(--color-text-muted)" }}
    />
);
